module.exports = __webpack_public_path__ + "img/P17-en.2f847c12.png";